export default "/images/framework/RuleCht.0553ae43.svg?0553ae43";